import usePermissions from './use-permissions';

export default function useHasPermissions(permissionGroupKey: string, permissionKey: string) {
  const { isAllowed } = usePermissions(permissionGroupKey);

  return isAllowed(permissionKey);
}
